import React from 'react'

// nodejs library to set properties for components
import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import Drawer from '@material-ui/core/Drawer'
import Typography from '@material-ui/core/Typography'

// @material-ui/icons
import { Menu, X } from 'react-feather'

// Components
import MenuLinks from 'components/Menu/MenuLinks.jsx'

const boxShadow = {
  boxShadow:
    '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
}

const transition = {
  transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
}

const drawerWidth = 300

const menuStyle = theme => ({
  appBar: {
    display: 'flex',
    border: '0',
    marginBottom: '20px',
    width: '100%',
    // boxShadow:
    // '0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)',
    // backgroundColor: fade(theme.palette.primary.main, 0.5) + ' !important',
    transition: 'all 150ms ease 0s',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-start',
    zIndex: '1100',
    position: 'fixed',
    [theme.breakpoints.up('sm')]: {
      padding: '0.625rem 0',
    },
  },
  container: {
    minHeight: '50px',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    flexWrap: 'nowrap',
  },
  flex: {
    flex: 1,
  },
  title: {
    ...theme.typography.h4,
    borderRadius: '3px',
    textTransform: 'none',
    color: 'inherit',
    '&:hover,&:focus': {
      color: 'inherit',
      background: 'transparent',
    },
  },
  appResponsive: {
    margin: '0px 24px',
  },
  drawerPaper: {
    border: 'none',
    bottom: '0',
    transitionProperty: 'top, bottom, width',
    transitionDuration: '.2s, .2s, .35s',
    transitionTimingFunction: 'linear, linear, ease',
    width: drawerWidth,
    ...boxShadow,
    position: 'fixed',
    display: 'block',
    top: '0',
    height: '100vh',
    maxHeight: '1200px',
    right: '0',
    left: 'auto',
    visibility: 'visible',
    // overflowY: 'visible',
    borderTop: 'none',
    textAlign: 'left',
    paddingRight: '0px',
    paddingLeft: '0',
    ...transition,
  },
})

// export default menuStyle
class AppMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileOpen: false,
    }
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this)
  }

  handleDrawerToggle() {
    this.setState({ mobileOpen: !this.state.mobileOpen })
  }

  render() {
    const { classes, brand, sections } = this.props

    return (
      <AppBar className={classes.appBar} elevation={0}>
        <Toolbar className={classes.container}>
          <Button className={classes.title} href="./#home">
            <Typography variant="h5" color="inherit">
              {brand}
            </Typography>
          </Button>
          <Hidden mdDown implementation="css">
            <MenuLinks sections={sections} />
          </Hidden>
          <Hidden lgUp>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerToggle}
            >
              <Menu />
            </IconButton>
          </Hidden>
        </Toolbar>
        <Hidden lgUp implementation="css">
          <Drawer
            anchor={'right'}
            onClick={this.handleDrawerToggle}
            onKeyDown={this.handleDrawerToggle}
            open={this.state.mobileOpen}
            classes={{ paper: classes.drawerPaper }}
          >
            <div className={classes.appResponsive}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={this.handleDrawerToggle}
                style={{ float: 'right' }}
              >
                <X />
              </IconButton>
              <MenuLinks sections={sections} />
            </div>
          </Drawer>
        </Hidden>
      </AppBar>
    )
  }
}

AppMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  rightLinks: PropTypes.node,
  brand: PropTypes.string,
}

export default withStyles(menuStyle)(AppMenu)
